import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import App from './app/app.vue'
import router from './app/app-routing'
import store from './store'
import '@styles/styles.scss'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://cf66b12d02a547808ae22588ae9aa538@trap.cekid.com/42',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    release: '',    // --sentry release--
  });
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
